import { useCallback } from 'react';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import type { FeedbackCollectorProps } from '@atlassian/jira-feedback-collector/src/types.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const ENTRYPOINT_ID = '980acd66-d10b-474a-9ff1-48928fc1c8ad';
export const FEEDBACK_GROUP_ID = 'gic.smart-fields';

// TODO: Delete this file when cleaning up smart_fields_gic_toggle_fg
export const useSmartFieldsFeedbackCollector = () => {
	const { openFeedbackCollector, resetFeedbackCollectorState } = useFeedbackCollectorActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const openSmartFieldsFeedbackCollector = useCallback(
		(feedbackCollectorProps: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				entrypointId: ENTRYPOINT_ID,
				feedbackGroupId: FEEDBACK_GROUP_ID,
				onClose: () => {
					fireUIAnalytics(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector closed');
					resetFeedbackCollectorState();
				},
				onSubmit: () => {
					fireUIAnalytics(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector submitted');
				},
				...feedbackCollectorProps,
			});
		},
		[openFeedbackCollector, createAnalyticsEvent, resetFeedbackCollectorState],
	);

	return { openSmartFieldsFeedbackCollector };
};
